import type { IComponentController, IScope } from "angular";
import type { IMonitoringNotificationSubscription, IPartnerUser } from "App/Modules/Models";

export default class SiteConfigurationGroupNotificationsInfoComponentController implements IComponentController {
    public static $inject: string[] = ["$scope"];

    public subscriptions: IMonitoringNotificationSubscription[];

    public notificationTypes: number[] = [];

    public subscribers: IPartnerUser[] = [];

    constructor(private readonly $scope: IScope) {}

    public $onChanges(changesObj: any) {
        if (!changesObj.subscriptions) {
            return;
        }

        this.updateViewData(changesObj.subscriptions.currentValue);
    }

    public updateViewData(subscriptions: IMonitoringNotificationSubscription[] = []) {
        this.notificationTypes = [];
        this.subscribers = [];

        subscriptions.forEach((sub) => {
            const typeExists = this.notificationTypes.some((n) => n === sub.notificationType);

            if (!typeExists) {
                this.notificationTypes.push(sub.notificationType);
            }

            const subscriberExists = this.subscribers.some((partnerUser) => partnerUser.id === sub.partnerUser.id);

            if (!subscriberExists) {
                this.subscribers.push(sub.partnerUser);
            }
        });
    }
}
